<template>
    <fragment>
        <div class="loader loader--only">
            <loader  v-show="!iframeHasLoaded"/>
        </div>
        <iframe 
            class="trustpay-iframe" 
            src="/chargebee/initiate" 
            @load="iframeLoaded" 
            :style="{ visibility: iframeHasLoaded ? 'visible' : 'hidden' }"
        ></iframe>
    </fragment>
</template>

<script>
import EnrolmentMixin from '@M/enrolment.js';
import { mapActions } from 'vuex';

export default {
    name: 'Payment Old',
    data() {
        return {
            iframeHasLoaded: false
        };
    },
    mixins: [EnrolmentMixin],
    methods: {
        iframeLoaded() {
            this.iframeHasLoaded = true;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Payment.vue